/* Pyros identities confirmed from Mika's reference, 21 Oct 2026. Scoped product enhancement. */
(function () {
  'use strict';
  var dataNode = document.querySelector('[data-pyros-model-data]');
  if (!dataNode) return;
  var data = JSON.parse(dataNode.textContent);
  var section = document.getElementById('shopify-section-' + data.section);
  if (!section || section.dataset.pyrosModelsReady) return;
  var buttons = Array.from(section.querySelectorAll('[data-sm-heater-variant]'));
  var gallery = section.querySelector('.featured-gallery-card');
  var slider = gallery && gallery.querySelector('.featured-product-slider');
  var rows = section.querySelector('[data-sm-heater-variants]');
  if (!rows || !gallery || !slider || !buttons.length) return;
  section.dataset.pyrosModelsReady = 'true';
  var language = (document.documentElement.lang || 'pt').split('-')[0];
  var copy = {
    es: {subtitle:'Tres tamaños: Pyros 12, 18 y 25. Angular y Round indican la forma de la cesta de piedras.',choose:'Elige tu modelo',stones:'Capacidad de piedras',details:'Medidas y ficha técnica',unknown:'Medidas y capacidad de piedras',request:'Consultar al equipo',photo:'¿Quieres ver este modelo? Pídenos una fotografía.',photoRequest:'Solicitar fotografía',gallery:'Explora los modelos',view:'Seleccionar',expert:'Habla con un especialista',note:'Piedras y chimenea se venden por separado.'},
    pt: {subtitle:'Três tamanhos: Pyros 12, 18 e 25. Angular e Round indicam a forma do cesto de pedras.',choose:'Escolha o seu modelo',stones:'Capacidade de pedras',details:'Medidas e ficha técnica',unknown:'Medidas e capacidade de pedras',request:'Consultar a equipa',photo:'Quer ver este modelo? Peça-nos uma fotografia.',photoRequest:'Pedir fotografia',gallery:'Explore os modelos',view:'Selecionar',expert:'Fale com um especialista',note:'Pedras e chaminé vendidas separadamente.'},
    en: {subtitle:'Three sizes: Pyros 12, 18 and 25. Angular and Round describe the shape of the stone basket.',choose:'Choose your model',stones:'Stone capacity',details:'Dimensions & technical sheet',unknown:'Dimensions & stone capacity',request:'Ask our team',photo:'Would you like to see this model? Ask our team for a photograph.',photoRequest:'Request a photograph',gallery:'Explore the models',view:'Select',expert:'Talk to a specialist',note:'Stones and chimney are sold separately.'},
    fr: {subtitle:'Trois tailles : Pyros 12, 18 et 25. Angular et Round désignent la forme du panier à pierres.',choose:'Choisissez votre modèle',stones:'Capacité de pierres',details:'Dimensions et fiche technique',unknown:'Dimensions et capacité de pierres',request:'Contacter notre équipe',photo:'Vous souhaitez voir ce modèle ? Demandez-nous une photographie.',photoRequest:'Demander une photographie',gallery:'Découvrez les modèles',view:'Choisir',expert:'Parler à un spécialiste',note:'Pierres et cheminée vendues séparément.'},
    it: {subtitle:'Tre misure: Pyros 12, 18 e 25. Angular e Round indicano la forma del cestello delle pietre.',choose:'Scegli il tuo modello',stones:'Capacità di pietre',details:'Dimensioni e scheda tecnica',unknown:'Dimensioni e capacità di pietre',request:'Chiedi al nostro team',photo:'Vuoi vedere questo modello? Chiedici una fotografia.',photoRequest:'Richiedi una fotografia',gallery:'Esplora i modelli',view:'Seleziona',expert:'Parla con uno specialista',note:'Pietre e canna fumaria vendute separatamente.'}
  };
  var t = copy[language] || copy.en;
  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }
  var expert = section.querySelector('.sm-wellness-topfold__cta-stack--direct .snm-ask-expert');
  if (expert) {
    var expertLabel = expert.querySelector('.sm-wellness-topfold__btn-label');
    if (expertLabel) expertLabel.textContent = t.expert;
  }
  function requestButton(text) {
    var button = el('button', 'sm-pyros-text-link', text);
    button.type = 'button';
    button.append(el('span', 'sm-pyros-link-arrow', '↗'));
    button.lastElementChild.setAttribute('aria-hidden', 'true');
    button.setAttribute('data-pyros-request', '');
    return button;
  }
  var guide = section.querySelector('[data-pyros-model-guide]');
  var placeholder = gallery.querySelector('.sm-pyros-photo-missing');
  var caption = gallery.querySelector('.sm-pyros-photo-caption');
  var photoNav = gallery.querySelector('.sm-pyros-photos');
  if (!guide || !placeholder || !caption || !photoNav) return;
  var images = data.models.filter(function (m) { return m.media; });
  function imageModel(image) {
    return image && images.find(function (m) { return image.src.indexOf(m.file) !== -1; });
  }
  section.addEventListener('click', function (event) {
    if (event.target.closest('[data-pyros-request]') && expert) expert.click();
  });
  photoNav.querySelectorAll('[data-pyros-photo-id]').forEach(function (button) {
    button.addEventListener('click', function () {
      var variant = buttons.find(function (b) { return b.dataset.variantId === button.dataset.pyrosPhotoId; });
      if (variant) variant.click();
    });
  });
  function updateCaption() {
    var model = imageModel(slider.querySelector('[data-pyros-hero]'));
    caption.replaceChildren();
    if (model) caption.append(el('span', '', model.name), el('span', 'sm-pyros-photo-count', String(images.indexOf(model) + 1).padStart(2, '0') + ' / ' + String(images.length).padStart(2, '0')));
  }
  var pendingMedia = null;
  function syncPhoto() {
    var model = images.find(function (m) { return m.media === pendingMedia; });
    var hero = slider.querySelector('[data-pyros-hero]');
    if (!model || !hero) return;
    var source = model.src;
    if (!source) {
      var thumb = photoNav.querySelector('[data-pyros-photo-id="' + model.id + '"] img');
      source = thumb && thumb.src.replace(/([?&])width=\d+/, '$1width=1200');
    }
    if (source && hero.getAttribute('src') !== source) hero.setAttribute('src', source);
    hero.alt = 'Saunamo ' + model.name;
    var zoom = slider.querySelector('[data-pyros-zoom]');
    if (zoom && source) { zoom.href = source; zoom.setAttribute('aria-label', model.name); }
    updateCaption();
  }
  var arrows = {es:['Modelo anterior','Modelo siguiente'],pt:['Modelo anterior','Modelo seguinte'],en:['Previous model','Next model'],fr:['Modèle précédent','Modèle suivant'],it:['Modello precedente','Modello successivo']};
  ['previous','next'].forEach(function (direction, index) {
    var control = gallery.querySelector('[data-pyros-' + direction + ']');
    if (!control) return;
    control.setAttribute('aria-label', (arrows[language] || arrows.en)[index]);
    control.addEventListener('click', function () {
      var current = images.findIndex(function (m) { return m.media === pendingMedia; });
      var next = images[(current + (index ? 1 : -1) + images.length) % images.length];
      var button = buttons.find(function (b) { return String(next.id) === b.dataset.variantId; });
      if (button) button.click();
    });
  });
  var stonesToggle = section.querySelector('[data-sm-stones-toggle]');
  function select(button, updateUrl) {
    if (button.disabled) return;
    var model = data.models.find(function (m) { return String(m.id) === button.dataset.variantId; });
    if (!model) return;
    guide.replaceChildren();
    guide.classList.toggle('sm-pyros-model-guide--unknown', !model.stones);
    if (model.stones) {
      var capacity = el('div', 'sm-pyros-capacity');
      capacity.append(el('strong', '', model.stones + ' kg'), el('span', '', t.stones));
      guide.append(capacity);
    }
    var technical = el('div', 'sm-pyros-technical');
    technical.append(el('span', '', model.stones ? t.details : t.unknown), requestButton(t.request));
    guide.append(technical);
    var hasPhoto = !!model.media;
    gallery.classList.toggle('sm-pyros-no-photo', !hasPhoto);
    placeholder.hidden = hasPhoto;
    caption.hidden = !hasPhoto;
    pendingMedia = model.media;
    if (hasPhoto) syncPhoto();
    photoNav.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.pyrosPhotoId === String(model.id))); });
    if (stonesToggle) {
      // Both Pyros 12 capacities still need manufacturer confirmation.
      if (!model.stones && stonesToggle.getAttribute('aria-checked') === 'true') stonesToggle.click();
      stonesToggle.hidden = !model.stones;
      stonesToggle.disabled = !model.stones;
    }
    if (updateUrl) {
      var url = new URL(location.href);
      url.searchParams.set('variant', model.id);
      history.replaceState(history.state, '', url);
    }
  }
  buttons.forEach(function (button) { button.addEventListener('click', function () { select(button, true); }); });
  section.dataset.pyrosDesign = '20261021';
  var active = section.querySelector('[data-sm-heater-variant].is-active');
  var initialModel = active && data.models.find(function (m) { return String(m.id) === active.dataset.variantId; });
  pendingMedia = initialModel && initialModel.media;
  // The selected hero and all layout markup are already rendered by Liquid.
})();
